module.exports = __webpack_public_path__ + "static/media/pathotrier.b00a5130.png";